/**
 * PORTED — RO-3-04 / #44297.
 * Origin: `excellent/app/customers/customers-cold-start.tsx`.
 *
 * Changes:
 *   next/navigation useRouter → @excellent/ui/router useNavigate
 *   router.refresh() on create → navigate to dossier (SPA has no server re-render;
 *     the next dashboard read re-evaluates `started`)
 *   SectionColdStart from the shared modes port
 * Live Next original UNTOUCHED (D6).
 */

import { useState } from "react";
import { useNavigate } from "@excellent/ui/router";
import { QuickCreateCustomer } from "@excellent/ui/blocks/crm/quick-create-customer";
import { SectionColdStart } from "../modes/section-cold-start";

export function CustomersColdStart({
  noun,
}: {
  noun: { singular: string; plural: string };
}) {
  const navigate = useNavigate();
  const [addOpen, setAddOpen] = useState(false);
  const one = noun.singular.toLowerCase();
  const many = noun.plural.toLowerCase();

  return (
    <div className="py-2">
      <SectionColdStart
        slug="sales"
        title={`Add your ${many}`}
        description={`Connect your CRM and an agent brings everyone in — deduped, enriched, and kept in sync. Or add your first ${one} by hand.`}
        manualLabel={`Add ${one} by hand`}
        onManual={() => setAddOpen(true)}
      />
      <QuickCreateCustomer
        open={addOpen}
        onOpenChange={setAddOpen}
        trigger={false}
        onCreated={() => {
          // SPA has no server re-render; re-enter the mode root so the
          // dashboard read re-evaluates `started` after the first account.
          navigate.push("/customers");
        }}
      />
    </div>
  );
}
